import { AttentionIndicator, type AttentionTone } from "../ui/AttentionIndicator";
import { appShellMetrics } from "./spacing";
export function AppShellStatusDot({ tone, label }: { tone?: AttentionTone | null; label?: string }) {
  return tone ? <AttentionIndicator tone={tone} label={label} dot pulse />
    : <span aria-hidden="true" style={{ width: appShellMetrics.contextStatusDotWidth, flexShrink: 0 }} />;
}
